var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_38_3706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 0C2.23853 0 0 2.23853 0 5C0 7.76147 2.23853 10 5 10C7.76147 10 10 7.76147 10 5C10 2.23853 7.76147 0 5 0ZM7.35065 4.06623L4.64978 6.7671C4.53939 6.87749 4.38961 6.93939 4.23333 6.93939C4.07706 6.93939 3.92727 6.87749 3.81688 6.7671L2.64892 5.59913C2.41905 5.36926 2.41905 4.9961 2.64892 4.76623C2.87922 4.53636 3.25195 4.53636 3.48182 4.76623L4.23333 5.51775L6.51775 3.23333C6.74762 3.00346 7.12078 3.00346 7.35065 3.23333C7.58052 3.46364 7.58052 3.83636 7.35065 4.06623Z",
    fill: "#00C04D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_3706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassCheck);
export default __webpack_public_path__ + "static/media/passCheck.d6e87b310bfcc4f7374b29fd341d922a.svg";
export { ForwardRef as ReactComponent };